import graphql__9ada33c49688bdb8b6c8 from "./__generated__/SendInvoiceDialog_invoice.graphql.ts";
import graphql__ae712a91abe7928775cd from "./__generated__/SendInvoiceDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import Hint from "../presentational/Hint";
import {FormattedDate, useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type SendInvoiceDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const SendInvoiceDialog: React.FC<SendInvoiceDialogProps> = (props) => {

    const intl = useIntl();
    const invoice = useFragment(
        graphql__9ada33c49688bdb8b6c8,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__ae712a91abe7928775cd,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToSendInvoice'})
            }
        )
    }

    const initialValues = {
        id: invoice.id
    }

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} headline={intl.formatMessage({id: 'dialog.SendInvoiceDialog.headline'})} submitLabel={intl.formatMessage({id: 'dialog.SendInvoiceDialog.submitLabel'})}>
            <Section>
                <Row>
                    <div className="text-gray-900">
                        <p>{intl.formatMessage({id: 'dialog.SendInvoiceDialog.question'})}</p>
                    </div>
                    {invoice.sentAt && (
                        <Hint className="py-4">
                            {intl.formatMessage({id: 'dialog.SendInvoiceDialog.alreadySentHint'}, {date: <FormattedDate value={invoice.sentAt}/>})}
                        </Hint>
                    )}
                </Row>
            </Section>
        </FormDialog>
    )
}

export default SendInvoiceDialog;
